import React, { ReactElement, useEffect, useState } from 'react';
import {Outlet, Navigate, useNavigation, useSearchParams, useLocation} from 'react-router-dom';
import { Loader } from 'common/components/Loader/Loader';
import { getFromLocalstorage } from 'common/utils/local-storage.utils';
import { EAuthFlagName } from 'domains/auth/constants/auth.constants';
import { ROUTES_MAPPING } from '../constants/route.constants';

const PublicRouteGuard = (): ReactElement => {
  const isAuth = getFromLocalstorage(EAuthFlagName);
  const { state } = useNavigation();
  const [searchParams] = useSearchParams();
  const from = searchParams.get('from') || '';
  const location = useLocation();
  const [redirectPath, setRedirectPath] =
    useState<string>(from?.length < 1 ? ROUTES_MAPPING.PROTECTED.DASHBOARD : from);

  useEffect(() => {
    if (location?.pathname.includes('reset-password')) {
      setRedirectPath(`${ROUTES_MAPPING.RESET_PASSWORD}/${location.search}`);
    }
  }, [location?.pathname]);

  return (
    <>
      {isAuth ? <Navigate to={redirectPath} /> : <Outlet />}
      {state === 'loading' && <Loader />}
    </>
  );
};

export default PublicRouteGuard;
